module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/banner_ritou-a6a8309a23179aa3e8fb4763f8062fec.png";